module.exports = __webpack_public_path__ + "static/media/FuturaStd-Book.c8761546.ttf";